function isNullOrUndefined(value) {
    return value === null || value === undefined;
}

export default isNullOrUndefined;
